import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import ObjectFitImages from "object-fit-images"

import css from "./FancyImage.module.scss";

import Sticky from "components/Sticky";

const themes = {
    fixed: "-theme-fixed",
    sticky: "-theme-sticky",
    full: "-theme-full",
    roundedCorners: "-theme-rounded-corners"
};

const gradients = {
    section: "-gradient-section",
    feature: "-gradient-feature"
};

class FancyImage extends React.Component {
    static propTypes = {
        alt: PropTypes.string,
        image: PropTypes.string.isRequired,
        imageMobile: PropTypes.string,
        theme: PropTypes.string,
        gradient: PropTypes.string,
        isMobile: PropTypes.bool
    };
    
    static defaultProps = {
        alt: ""
    };
    

    componentDidMount(){
        ObjectFitImages("img."+css.image)
    }

    themeConditions = (theme,imageMobile,isMobile) => {
        if (theme === themes.full) return imageMobile && isMobile;
        return theme;
    };

    render(){
        const {theme,gradient, alt, isMobile, image,imageMobile} = this.props;
        const src = isMobile ? imageMobile || image : image;
        
        return (
            <div
                className={cn(css.imageWrapper, {
                    [css.gradient]: gradient,
                    [css[gradient]]: gradient,
                    [css[theme]]: this.themeConditions(theme,imageMobile,isMobile)
                })}
            >
                <Sticky type="img" props={{
                    src,
                    alt,
                    className:cn(css.image, {
                        [css[gradient]]: gradient
                    })
                }   
                }
                isSticky={theme === "-theme-sticky"} />
            </div>
        );
    }
}

FancyImage.themes = themes;

FancyImage.gradients = gradients;

export default FancyImage;



// WEBPACK FOOTER //
// ./src/components/FancyImage/FancyImage.jsx